//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RadialProgressBar from "vue-radial-progress";
import {mapGetters, mapMutations} from "vuex";
import MissionActivity from "@/components/mission/MissionActivity";
import Missions from "@/components/mission/Missions";

export default {
  name: "User",

  components: {
    Missions,
    MissionActivity,
    RadialProgressBar,
  },

  data: () => ({
    user: {},
    totalAnnotations: 0,
    level: 1,
  }),

  computed: {

    username: function () {
      if (this.user && Object.keys(this.user).length !== 0) {
        return this.user.properties.username;
      }
      return "John Doe";
    },
    initial: function () {
      if (this.user && Object.keys(this.user).length !== 0) {
        return this.user.properties.username.charAt(0);
      }
      return "@";
    },
    ...mapGetters(["projectId", "missions"]),
    pendingMissions: function () {
      if (this.missions) {
        return this.missions.length;
      }
      return 0;
    },
    closedMissions: function () {
      if (this.missions) {
        return this.missions.length;
      }
      return 0;
    },
    performance: function () {
      let performanceOutput = "...";
      if (this.missions) {
        let performance = 0;
        this.missions.forEach((mission) => {
          let missionPerf = 0;
          if (mission.contextParameters.mission && mission.contextParameters.mission.evaluation_result) {
            const evalResults = Object.values(mission.contextParameters.mission.evaluation_result);
            if (evalResults.length !== 0) {
              const initialPerf = evalResults[0]['main_result'];
              const finalPerf = evalResults[evalResults.length - 1]['main_result'];
              missionPerf = finalPerf - initialPerf;
            }
          }
          performance += missionPerf;
        });
        if (performance > 0) {
          performanceOutput = (performance * 100).toFixed(2).toString() + ' %';
        }
      }
      return performanceOutput;
    },
    levelProgress: function () {
      return this.level * 10;
    },
  },

  mounted() {
    this.$refs.fetchUser.get().then((user) => {
      this.user = user;
      this.fetchMetrics();
    }).catch((error) => {
      this.displayError(error);
    });
  },

  methods: {
    ...mapMutations({
      displayError: "displayError",
    }),
    fetchMetrics() {
      this.$refs.fetchMetrics.params = {
        'userId': this.user.properties.username
      };
      this.$refs.fetchMetrics.params.all = false;
      this.$refs.fetchMetrics
          .get()
          .then(response => {
            if (response && response.hits) {
              this.totalAnnotations = response.hits.total;
              if (this.totalAnnotations === 0) {
                this.level = 1;
              } else {
                this.level = Math.log10(this.totalAnnotations).toFixed(0);
              }
            }
          });
    },
  }
}
